import React, { useEffect, useState } from "react";
import { Link, Outlet, useNavigate, useLocation } from "react-router-dom";
import loginimg from "../images/logo.jpg";
import { getUserName } from "./Auth";
import Notificacoes from "./notificacaoes";
import "../css/dashboard.css"; // Importe o CSS novo

function Dashboard() {
  const navigate = useNavigate();
  const location = useLocation(); // Para saber qual rota está ativa
  const [isSidebarOpen, setIsSidebarOpen] = useState(true); // Controla Sidebar
  const [isProcessoOpen, setIsProcessoOpen] = useState(false); // Controla Dropdown
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  // Verifica login e tamanho da tela ao iniciar
  useEffect(() => {
    const token = localStorage.getItem("Token");
    setIsLoggedIn(!!token);

    const handleResize = () => {
      const mobile = window.innerWidth < 768;
      setIsMobile(mobile);
      if (mobile)
        setIsSidebarOpen(false); // Fecha sidebar no mobile
      else setIsSidebarOpen(true); // Abre no desktop
    };

    window.addEventListener("resize", handleResize);
    handleResize(); // Checa inicial

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const signOut = () => {
    localStorage.clear(); // Limpa tudo de uma vez
    navigate("/");
    window.location.reload();
  };

  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);

  // Fecha sidebar ao clicar no overlay (mobile)
  const closeSidebarMobile = () => {
    if (isMobile) setIsSidebarOpen(false);
  };

  return (
    <div className="dashboard-layout">
      {/* Overlay Escuro (Só aparece no mobile quando menu aberto) */}
      <div
        className={`mobile-overlay ${isMobile && isSidebarOpen ? "active" : ""}`}
        onClick={closeSidebarMobile}
      ></div>

      {/* --- SIDEBAR --- */}
      <aside
        className={`sidebar-container ${isSidebarOpen ? "open" : "closed"}`}
      >
        <div className="sidebar-logo">
          <img src={loginimg} alt="Logo" className="loginimg" />
        </div>

        <ul className="sidebar-menu">
          {/* Item: Home / Dashboard */}
          <li className="menu-item">
            <Link
              to="/"
              className={`menu-link ${location.pathname.includes("home") ? "active-route" : ""}`}
            >
              <i className="fa-solid fa-chart-line menu-icon"></i>
              <span>Dashboard Geral</span>
            </Link>
          </li>

          {/* Item: Processos (Dropdown) */}
          <li className="menu-item">
            <div
              className="menu-link"
              onClick={() => setIsProcessoOpen(!isProcessoOpen)}
              style={{ justifyContent: "space-between" }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <i className="fa-solid fa-folder-open menu-icon"></i>
                <span>Processos</span>
              </div>
              <i
                className={`fa-solid fa-chevron-down arrow-icon ${isProcessoOpen ? "rotated" : ""}`}
              ></i>
            </div>

            <ul className={`submenu ${isProcessoOpen ? "open" : ""}`}>
              <li>
                <Link to="/graficobarra" className="submenu-link">
                  <i
                    className="fa-solid fa-chart-bar menu-icon"
                    style={{ fontSize: "0.8em" }}
                  ></i>{" "}
                  Painel Quantitativo
                </Link>
              </li>
              <li>
                <Link to="/projetocompleto" className="submenu-link">
                  <i
                    className="fa-solid fa-list menu-icon"
                    style={{ fontSize: "0.8em" }}
                  ></i>{" "}
                  Lista Completa
                </Link>
              </li>
            </ul>
          </li>

          {/* Outros Itens */}
          <li className="menu-item">
            <Link to="/listapca" className="menu-link">
              <i className="fa-solid fa-file-contract menu-icon"></i>
              <span>PCA</span>
            </Link>
          </li>
          <li className="menu-item">
            <Link to="/orcamento" className="menu-link">
              <i className="fa-solid fa-sack-dollar menu-icon"></i>
              <span>Orçamento</span>
            </Link>
          </li>
          <li className="menu-item">
            <Link to="/projetosbairros" className="menu-link">
              <i className="fa-solid fa-map-location-dot menu-icon"></i>
              <span>Por Bairros</span>
            </Link>
          </li>
          <li className="menu-item">
            <Link to="/conveniosdade" className="menu-link">
              <i className="fa-solid fa-handshake menu-icon"></i>
              <span>Convênios</span>
            </Link>
          </li>
          <li className="menu-item">
            <Link to="/mapa" className="menu-link">
              <i className="fa-solid fa-map menu-icon"></i>
              <span>Mapa de Obras</span>
            </Link>
          </li>
        </ul>

        {/* Footer Sidebar (Logout) */}
        <div className="sidebar-footer">
          {isLoggedIn ? (
            <button className="btn-logout" onClick={signOut}>
              <i className="fa-solid fa-power-off"></i>{" "}
              <span>Sair do Sistema</span>
            </button>
          ) : (
            <button
              className="btn-logout"
              onClick={() => navigate("/login")}
            >
              <i className="fa-solid fa-sign-in-alt"></i> <span>Entrar</span>
            </button>
          )}
        </div>
      </aside>

      {/* --- ÁREA PRINCIPAL --- */}
      <div className="main-wrapper">
        {/* Top Header */}
        <header className="top-bar">
          <div style={{ display: "flex", alignItems: "center", gap: "15px" }}>
            <button className="toggle-btn" onClick={toggleSidebar}>
              <i className="fa-solid fa-bars"></i>
            </button>
            {!isLoggedIn && (
          <button onClick={() => navigate("/login")} className="btn-login">
            <i className="fas fa-user-circle me-2"></i> Usuario Deslogado
          </button>
        )}
            <h6 className="header-title d-none d-md-block m-0">
              Prefeitura de Guaratinguetá - Gestão
            </h6>
          </div>

          <div className="user-info">
            {isLoggedIn && (
              <>
                <Notificacoes />
                <span>
                  Olá, <span className="user-name">{getUserName()}</span>
                </span>
              </>
            )}
          </div>
        </header>

        {/* Conteúdo das Páginas */}
        <div className="content-area">
          <Outlet />
        </div>
      </div>
    </div>
  );
}

export default Dashboard;
